import { render, staticRenderFns } from "./switchAccount.vue?vue&type=template&id=3310afbf&"
import script from "./switchAccount.vue?vue&type=script&lang=js&"
export * from "./switchAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports